RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Companies = Marionette.CompositeView.extend({
        tagName: 'table',
        className: 'table',
        template: '#adminCompaniesTemplate',
        childViewContainer: 'tbody',

        childView: views.Company,
        emptyView: RivalIQ.apps.Admin.views.EmptyResults,
        emptyViewOptions: function () {
            const me = this;

            return {
                emptyMessage: me.options.emptyMessage
            };
        }
    });
});
